import React, { useMemo } from 'react';
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom';
import { preserveQuery } from '@/utils/preserveQuery';

/**
 * A NavLink wrapper that automatically preserves search params from the
 * current URL (e.g. ?systemSource=GDS_NEO).
 */
const PreserveQueryNavLink: React.FC<NavLinkProps> = ({ to, ...props }) => {
  const location = useLocation();

  const toWithSearch = useMemo(
    () => preserveQuery(to, location.search),
    [to, location.search]
  );

  return <NavLink to={toWithSearch} {...props} />;
};

export default PreserveQueryNavLink;
